import type { FollowUpMomentDetails } from "../hooks/use-follow-up-moment-details";
import type { FollowUpChannelWithData } from "./schema";

export function parseMomentFollowUpChannel(data: FollowUpMomentDetails): FollowUpChannelWithData {
  switch (data.channel) {
    case "slack":
      return {
        channel: "slack",
        channelData: { slack_alias_id: null },
      };
    case "teams":
      return {
        channel: "teams",
        channelData: undefined,
      };
    case "twilio":
      return {
        channel: "twilio",
        channelData: undefined,
      };
    case "work_email":
    case "personal_email":
      return {
        channel: data.channel,
        channelData: {
          email_sender: "",
          email_subject: "",
          email_design_id: null,
        },
      };
    default:
      return {
        channel: "work_email",
        channelData: {
          email_sender: "",
          email_subject: "",
          email_design_id: null,
        },
      };
  }
}
